const filterConnections = (list, isOutgoing) => {
  const key = isOutgoing ? 'sent' : 'received';

  const filtered = list.filter(item => item[key].total);
  return filtered.sort((a, b) => Number(a[key].hops) - Number(b[key].hops));
};

export default filterConnections;



// WEBPACK FOOTER //
// ./src/shared/utils/helpers/filterAmlConnections.js